import { Box, Button, Card, CardContent, Grid, TextField } from "@mui/material";
import { SpinnerOverlay } from "components/molecules/SpinnerOverlay";
import { FormikErrors, useFormik } from "formik";
import _ from "lodash";
import { IAuthenticateRequest } from "model";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IdentityActions } from "redux/actions";
import { RootReducer } from "redux/configurations/rootReducer";
import { _t, translations } from "utils/i18n";

export const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const action = useSelector(
    (state: RootReducer) => state.IdentityReducer.action
  );

  const deviceId = useSelector(
    (state: RootReducer) => state.IdentityReducer.deviceId
  );

  useEffect(() => {
    if (action.includes(IdentityActions.getCurrentUser.successName)) {
      history.push("/master-data/product-configuration");
      dispatch(IdentityActions.clearAction.request());
    }
  }, [action]);
  const { t } = useTranslation();
  const initialValues: IAuthenticateRequest = {
    userNameOrEmail: "",
    password: "",
    rememberMe: false,
  };
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: (values: IAuthenticateRequest) => {
      const request: IAuthenticateRequest = {
        ...values,
        deviceId: deviceId,
      };
      dispatch(IdentityActions.authenticate.request(request));
    },
    validate: (values: IAuthenticateRequest) => {
      const errors: FormikErrors<IAuthenticateRequest> = {};
      if (_.isEmpty(values.userNameOrEmail)) {
        errors.userNameOrEmail = t(_t(translations.login.blankUserName));
      }
      if (_.isEmpty(values.password)) {
        errors.password = t(_t(translations.login.blankPassword));
      }
      return errors;
    },
  });

  return (
    <Box>
      <Grid
        sx={{ height: "100vh" }}
        container
        alignItems="center"
        justifyContent="center"
      >
        <Card
          sx={{
            margin: "0 20px",
          }}
        >
          <CardContent
            sx={{
              width: 500,
              maxWidth: 500,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Box sx={{ py: 1, mb: 1 }}>
              <img
                alt="elanco-logo-login"
                src={require("assets/images/logo-primary.png")}
                style={{
                  height: "60px",
                }}
              />
            </Box>
            <Grid
              container
              spacing={2}
              component="form"
              onSubmit={formik.handleSubmit}
              sx={{ mt: 2 }}
            >
              <Grid item xs={12}>
                <TextField
                  sx={{ width: "100%" }}
                  id="userNameOrEmail"
                  name="userNameOrEmail"
                  label={t(_t(translations.username))}
                  error={
                    formik.touched.userNameOrEmail &&
                    !_.isEmpty(formik.errors.userNameOrEmail)
                  }
                  helperText={
                    formik.touched.userNameOrEmail &&
                    formik.errors.userNameOrEmail
                  }
                  value={formik.values.userNameOrEmail}
                  onChange={formik.handleChange}
                  size="medium"
                  autoComplete="false"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ width: "100%" }}
                  error={
                    formik.touched.password &&
                    !_.isEmpty(formik.errors.password)
                  }
                  helperText={formik.touched.password && formik.errors.password}
                  id="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  type="password"
                  name="password"
                  label={t(_t(translations.password))}
                  size="medium"
                  autoComplete="false"
                />
              </Grid>

              <Grid item container justifyContent="center" xs={12}>
                <Button
                  size="large"
                  variant="contained"
                  sx={{ width: "100%" }}
                  type="submit"
                >
                  {t(_t(translations.login.login))}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <SpinnerOverlay show={action.includes("_REQUEST")} />
    </Box>
  );
};
